import { mergeStyleSets } from "@uifabric/merge-styles";
import AttachmentsPanel from "components/attachments/AttachmentsPanel";
import { isExternalOrReadonlyAdmin } from "form/util";
import React from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { Attachment, Vehicle } from "types/types";
import { useSelector } from "../../../store/hooks";
import { setVehicle } from "../../../store/vehicle";
import FormItemTitle from "../FormItemTitle";

const classes = mergeStyleSets({
  container: {
    padding: 40,
  },
});

type Props = {
  vehicle: Vehicle;
  route: string;
};

// Documents of a vehicle; only internal users on the edit page may change them
const AttachmentsSection = ({ vehicle, route }: Props) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const userRole = useSelector((s) => s.auth.userRole);

  const canEdit =
    route === "editVehicle" && !isExternalOrReadonlyAdmin(userRole);

  // a document change creates a new vehicle version: take over the vehicle's new row version and last modified data,
  // otherwise the next save of the vehicle form would fail with "updated by another user"
  const onAttachmentsChange = (next: Attachment[], changed: Attachment) => {
    const vehiclePatch = changed?.vehicleRowVersion
      ? {
          rowVersion: changed.vehicleRowVersion,
          vehicleLastModifiedAt:
            changed.vehicleLastModifiedAt ?? vehicle.vehicleLastModifiedAt,
          vehicleLastModifiedByUserId: changed.lastModifiedByUserId,
          vehicleLastModifiedByUserName: changed.lastModifiedByUserName,
          vehicleLastModifiedByUserEmail: changed.lastModifiedByUserEmail,
        }
      : {};
    dispatch(setVehicle({ ...vehicle, ...vehiclePatch, attachments: next }));
  };

  return (
    <div className={classes.container}>
      <FormItemTitle
        title={t("bfm.vehicle.tabs.attachments")}
        iconName={"Attach"}
        iconMargin={0}
      />
      <AttachmentsPanel
        fleetId={vehicle.fleetId}
        vehicleId={vehicle.vehicleId}
        attachments={vehicle.attachments}
        onAttachmentsChange={onAttachmentsChange}
        canEdit={canEdit}
      />
    </div>
  );
};

export default AttachmentsSection;
